export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL";
export const USER_LOGOUT = "USER_LOGOUT";

export const USER_LIST_REQUEST = "USER_LIST_REQUEST";
export const USER_LIST_SUCCESS = "USER_LIST_SUCCESS";
export const USER_LIST_FAIL = "USER_LIST_FAIL";
export const USER_LIST_RESET = "USER_LIST_RESET";

// USER LOCK
export const USER_LOCK_REQUEST = "USER_LOCK_REQUEST";
export const USER_LOCK_SUCCESS = "USER_LOCK_SUCCESS";
export const USER_LOCK_FAIL = "USER_LOCK_FAIL";

// USER UNLOCK
export const USER_UNLOCK_REQUEST = "USER_UNLOCK_REQUEST";
export const USER_UNLOCK_SUCCESS = "USER_UNLOCK_SUCCESS";
export const USER_UNLOCK_FAIL = "USER_UNLOCK_FAIL";
